module.exports = __webpack_public_path__ + "img/game_glive_x.8a63cc1.jpg";